import request from 'local_modules/request'
import { constants, requestWithMock } from 'helpers'


const fetchManualFilter = ({ date, ShiftScheduleId }) => {
  return requestWithMock(constants.lscSchedules.orderManualFilter + `?date=${date}&ShiftScheduleId=${ShiftScheduleId}`)
    .then(({ data }) => data)
}

const setManualFilter = ({ date, shiftScheduleId, bus, driverId, conductorId }) => {
  const sendData = {
    date,
    shiftScheduleId,
  }

  if (bus !== '-') {
    sendData.bus = bus
  }
  if (driverId !== '-') {
    sendData.driverId = driverId
  }
  if (conductorId !== '-') {
    sendData.conductorId = conductorId
  }

  return request.post(constants.lscSchedules.orderManualSet, sendData)
    .then(({ data }) => data)
}


export default {
  fetchManualFilter,
  setManualFilter,
}
